import axiosInstance from "@/utils/axiosInstance";

const baseUrl = `api/building-transfers`;

const state = {};

const getters = {};

const mutations = {};

const actions = {
  requestTransfer({commit}, payload: {
    registrationNumber: string,
    contactEmail: string,
    relayId: number,
  }): Promise<any> {
    return axiosInstance.post(`${baseUrl}`, {
      registrationNumber: payload.registrationNumber,
      contactEmail: payload.contactEmail,
      relayId: payload.relayId,
    }).then((data) => data.data);
  },
  acceptTransfer({commit}, payload: {
    transferId: string,
  }): Promise<any> {
    return axiosInstance.post(`${baseUrl}/${payload.transferId}/accept`, {})
    .then((data) => data.data);
  },
  abort({commit}, payload: {
    transferId: string,
  }): Promise<any> {
    return axiosInstance.post(`${baseUrl}/${payload.transferId}/abort`, {})
    .then((data) => data.data);
  },
};

export default {
  namespaced: true, state, getters, actions, mutations,
};
